package diana.soleil.design.iraniancanadienbazzar.feature.gems

import androidx.compose.foundation.background
import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.pager.VerticalPager
import androidx.compose.foundation.pager.rememberPagerState
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.platform.LocalClipboardManager
import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.text.style.TextAlign
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import diana.soleil.design.iraniancanadienbazzar.core.common.ShareService
import diana.soleil.design.iraniancanadienbazzar.core.data.ShareConfig
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppCard
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppChip
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIcon
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIconButton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppSearchBar
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.EmptyState
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.LoadingState
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.PlatformStatusBarAppearance
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ReportReason
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ReportSheet
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ReportStatus
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme
import diana.soleil.design.iraniancanadienbazzar.core.model.Fact
import diana.soleil.design.iraniancanadienbazzar.core.model.FactCategory
import diana.soleil.design.iraniancanadienbazzar.core.model.formatCount
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.Res
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_back_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_copied
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_copy_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_dan_cat_canada
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_dan_cat_community
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_dan_cat_history
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_dan_cat_iran
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_dan_cat_language
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_dan_cat_nature
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_dan_empty_desc
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_dan_empty_title
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_dan_search_placeholder
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_dan_title
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_error
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_filter_all
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_jokes_counter
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_like_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_more_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_report_done
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_report_failed
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_report_reason_offensive
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_report_reason_other
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_report_reason_spam
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_report_sent
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_report_submit
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_report_title
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_save_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_search_close_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_search_open_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_share_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_share_message
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_swipe_hint
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.koinInject
import org.koin.compose.viewmodel.koinViewModel
import kotlinx.coroutines.launch

/** Stateful entry for the Danestaniha browser (`/gems/danestaniha`). */
@Composable
fun DanestanihaRoute(
    onBack: () -> Unit,
    onRequireSignIn: () -> Unit,
    modifier: Modifier = Modifier,
    /** Open on this fact (daily-gem push); null starts at the first card. */
    focusFactId: String? = null,
    viewModel: DanestanihaViewModel = koinViewModel(),
) {
    val state by viewModel.state.collectAsStateWithLifecycle()
    val shareService = koinInject<ShareService>()
    val shareConfig = koinInject<ShareConfig>()
    val lang = AppTheme.language

    LaunchedEffect(state.signInRequired) {
        if (state.signInRequired) {
            viewModel.consumeSignInGate()
            onRequireSignIn()
        }
    }
    LaunchedEffect(state.reportStatus) {
        if (state.reportStatus == GemReportStatus.SignInRequired) {
            viewModel.resetReport()
            onRequireSignIn()
        }
    }

    val shareTemplate = stringResource(Res.string.gems_share_message)
    DanestanihaScreen(
        state = state,
        onBack = onBack,
        onSelectCategory = viewModel::setCategory,
        onQueryChange = viewModel::onQueryChange,
        onToggleLike = viewModel::toggleLike,
        onToggleSave = viewModel::toggleSave,
        onShare = { fact ->
            shareService.share(
                shareTemplate
                    .replace("%1\$s", fact.text.resolve(lang))
                    .replace("%2\$s", shareConfig.factLink(fact.id)),
            )
        },
        onReport = viewModel::report,
        onResetReport = viewModel::resetReport,
        modifier = modifier,
        focusFactId = focusFactId,
    )
}

/**
 * Danestaniha (دانستنی‌ها) swipe reader: full-screen vertical pager (one fact per page), a
 * lightbulb ornament + big centered text + optional source line, an end-edge action rail
 * (like/save/copy/share/report), topic chips, expanding search, a "3/40" counter and a swipe-up
 * hint. Double-tap the card to like. Start/end layout only — the rail mirrors in RTL.
 */
@Composable
fun DanestanihaScreen(
    state: DanestanihaUiState,
    onBack: () -> Unit,
    onSelectCategory: (FactCategory?) -> Unit,
    onQueryChange: (String) -> Unit,
    onToggleLike: (factId: String, liked: Boolean) -> Unit,
    onToggleSave: (factId: String) -> Unit,
    onShare: (Fact) -> Unit,
    onReport: (factId: String, reason: String) -> Unit,
    onResetReport: () -> Unit,
    modifier: Modifier = Modifier,
    focusFactId: String? = null,
) {
    val lang = AppTheme.language
    val clipboard = LocalClipboardManager.current
    val snackbarHostState = remember { SnackbarHostState() }
    val scope = rememberCoroutineScope()
    val copiedMessage = stringResource(Res.string.gems_copied)
    var searchOpen by remember { mutableStateOf(false) }
    var reportFactId by remember { mutableStateOf<String?>(null) }
    // Jump to the pushed fact once, the first time it is in the list — later swipes stay the user's.
    var focusConsumed by remember(focusFactId) { mutableStateOf(focusFactId == null) }

    PlatformStatusBarAppearance(lightIcons = true)

    Box(modifier = modifier.fillMaxSize().background(AppTheme.colors.surfaceContainer)) {
        Column(modifier = Modifier.fillMaxSize()) {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .background(AppTheme.colors.brandBand)
                    .statusBarsPadding().navigationBarsPadding(),
            ) {
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(horizontal = AppTheme.spacing.md, vertical = AppTheme.spacing.sm),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
                ) {
                    AppIconButton(
                        iconName = "arrow_back",
                        contentDescription = stringResource(Res.string.gems_back_a11y),
                        onClick = onBack,
                        tint = AppTheme.colors.onPrimary,
                    )
                    Text(
                        text = stringResource(Res.string.gems_dan_title),
                        style = AppTheme.typography.headlineMd,
                        color = AppTheme.colors.onPrimary,
                        modifier = Modifier.weight(1f),
                    )
                    AppIconButton(
                        iconName = if (searchOpen) "close" else "search",
                        contentDescription = stringResource(
                            if (searchOpen) Res.string.gems_search_close_a11y else Res.string.gems_search_open_a11y,
                        ),
                        onClick = {
                            if (searchOpen) onQueryChange("")
                            searchOpen = !searchOpen
                        },
                        tint = AppTheme.colors.onPrimary,
                    )
                }
                if (searchOpen) {
                    AppSearchBar(
                        value = state.query,
                        onValueChange = onQueryChange,
                        placeholder = stringResource(Res.string.gems_dan_search_placeholder),
                        leading = { AppIcon("search", tint = AppTheme.colors.onSurfaceVariant) },
                        modifier = Modifier
                            .padding(horizontal = AppTheme.spacing.lg)
                            .padding(bottom = AppTheme.spacing.md),
                    )
                }
            }

            FactCategoryChips(selected = state.category, onSelectCategory = onSelectCategory)

            when {
                state.loading -> LoadingState()
                state.error -> EmptyState(title = stringResource(Res.string.gems_error))
                state.facts.isEmpty() -> EmptyState(
                    title = stringResource(Res.string.gems_dan_empty_title),
                    description = stringResource(Res.string.gems_dan_empty_desc),
                )
                else -> {
                    val pagerState = rememberPagerState(pageCount = { state.facts.size })
                    LaunchedEffect(focusFactId, state.facts) {
                        if (focusConsumed) return@LaunchedEffect
                        val index = state.facts.indexOfFirst { it.id == focusFactId }
                        if (index >= 0) {
                            pagerState.scrollToPage(index)
                            focusConsumed = true
                        }
                    }
                    Box(modifier = Modifier.weight(1f)) {
                        VerticalPager(
                            state = pagerState,
                            modifier = Modifier.fillMaxSize(),
                        ) { page ->
                            val fact = state.facts[page]
                            FactPage(
                                fact = fact,
                                counter = stringResource(
                                    Res.string.gems_jokes_counter,
                                    lang.formatCount(page + 1),
                                    lang.formatCount(state.facts.size),
                                ),
                                categoryLabel = fact.category.label(),
                                liked = fact.id in state.likedFactIds,
                                saved = fact.id in state.savedFactIds,
                                onDoubleTapLike = {
                                    if (fact.id !in state.likedFactIds) onToggleLike(fact.id, false)
                                },
                                onToggleLike = { onToggleLike(fact.id, fact.id in state.likedFactIds) },
                                onToggleSave = { onToggleSave(fact.id) },
                                onCopy = {
                                    clipboard.setText(AnnotatedString(fact.text.resolve(lang)))
                                    scope.launch { snackbarHostState.showSnackbar(copiedMessage) }
                                },
                                onShare = { onShare(fact) },
                                onMore = { reportFactId = fact.id },
                            )
                        }
                        if (pagerState.currentPage < state.facts.size - 1) {
                            Column(
                                modifier = Modifier
                                    .align(Alignment.BottomCenter)
                                    .padding(bottom = AppTheme.spacing.md),
                                horizontalAlignment = Alignment.CenterHorizontally,
                            ) {
                                Text(
                                    text = stringResource(Res.string.gems_swipe_hint),
                                    style = AppTheme.typography.labelSm,
                                    color = AppTheme.colors.onSurfaceVariant,
                                )
                                AppIcon(
                                    name = "keyboard_arrow_up",
                                    size = AppTheme.sizes.iconSm,
                                    tint = AppTheme.colors.onSurfaceVariant,
                                )
                            }
                        }
                    }
                }
            }
        }
        SnackbarHost(
            hostState = snackbarHostState,
            modifier = Modifier.align(Alignment.BottomCenter),
        )
    }

    reportFactId?.let { factId ->
        ReportSheet(
            title = stringResource(Res.string.gems_report_title),
            reasons = listOf(
                ReportReason(stringResource(Res.string.gems_report_reason_offensive), "offensive"),
                ReportReason(stringResource(Res.string.gems_report_reason_spam), "spam"),
                ReportReason(stringResource(Res.string.gems_report_reason_other), "other"),
            ),
            status = when (state.reportStatus) {
                GemReportStatus.Sending -> ReportStatus.Sending
                GemReportStatus.Sent -> ReportStatus.Sent
                GemReportStatus.Failed -> ReportStatus.Failed
                else -> ReportStatus.Idle
            },
            sentText = stringResource(Res.string.gems_report_sent),
            failedText = stringResource(Res.string.gems_report_failed),
            submitText = stringResource(Res.string.gems_report_submit),
            doneText = stringResource(Res.string.gems_report_done),
            onSubmit = { reason -> onReport(factId, reason) },
            onDismiss = {
                reportFactId = null
                onResetReport()
            },
        )
    }
}

/** Topic chip rail (All / Iran / Canada / Community / History / Language / Nature). */
@Composable
private fun FactCategoryChips(
    selected: FactCategory?,
    onSelectCategory: (FactCategory?) -> Unit,
) {
    val categories = remember { FactCategory.entries.toList() }
    LazyRow(
        modifier = Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
        contentPadding = PaddingValues(
            horizontal = AppTheme.spacing.lg,
            vertical = AppTheme.spacing.md,
        ),
    ) {
        item("all") {
            AppChip(
                label = stringResource(Res.string.gems_filter_all),
                selected = selected == null,
                onClick = { onSelectCategory(null) },
            )
        }
        items(categories, key = { it.name }) { category ->
            AppChip(
                label = category.label(),
                selected = selected == category,
                onClick = { onSelectCategory(category) },
            )
        }
    }
}

/** One pager page: a full-bleed gradient story card ([GemStoryCard]) with the fact + source. */
@Composable
private fun FactPage(
    fact: Fact,
    counter: String,
    categoryLabel: String,
    liked: Boolean,
    saved: Boolean,
    onDoubleTapLike: () -> Unit,
    onToggleLike: () -> Unit,
    onToggleSave: () -> Unit,
    onCopy: () -> Unit,
    onShare: () -> Unit,
    onMore: () -> Unit,
) {
    val lang = AppTheme.language
    GemStoryCard(
        key = fact.id,
        // Each topic keeps a stable gradient so the section feels varied yet coherent.
        gradient = AppTheme.gradients.storyCard(fact.category.ordinal),
        watermark = "lightbulb",
        counter = counter,
        categoryLabel = categoryLabel,
        text = fact.text.resolve(lang),
        source = fact.source?.resolve(lang)?.takeIf { it.isNotBlank() },
        likeCount = fact.likeCount,
        liked = liked,
        saved = saved,
        onDoubleTapLike = onDoubleTapLike,
        onToggleLike = onToggleLike,
        onToggleSave = onToggleSave,
        onCopy = onCopy,
        onShare = onShare,
        onMore = onMore,
    )
}

/** Localized display label for a Danestaniha topic (app chrome, never content). */
@Composable
internal fun FactCategory.label(): String = stringResource(
    when (this) {
        FactCategory.Iran -> Res.string.gems_dan_cat_iran
        FactCategory.Canada -> Res.string.gems_dan_cat_canada
        FactCategory.Community -> Res.string.gems_dan_cat_community
        FactCategory.History -> Res.string.gems_dan_cat_history
        FactCategory.Language -> Res.string.gems_dan_cat_language
        FactCategory.Nature -> Res.string.gems_dan_cat_nature
    },
)
